/** 是否允许 Drei ScrollControls 响应滚动；弹窗或特殊交互可临时关闭它。 */
import { atom, useRecoilState } from 'recoil';

const scrollControlsState = atom<boolean>({
    key: 'scrollControlsState',
    default: true,
});

export const useScrollControlsState = () => useRecoilState(scrollControlsState);
